import React, { Component } from 'react';

export default class Footer extends Component {
  render() {
    return (
      <React.Fragment>
      {
		<footer>
			<div className="row">
				<div className="twelve columns">
					<ul className="social-links">
						<li><a href="https://www.facebook.com/profile.php?id=100010505551221"><i className="fa fa-facebook" /></a></li>
						<li><a href="https://twitter.com/jaymbo78"><i className="fa fa-twitter" /></a></li>
						<li><a href="https://plus.google.com/108809628727284696980"><i className="fa fa-google-plus" /></a></li>
						<li><a href="https://be.linkedin.com/in/gabriele-cassano-57403958"><i className="fa fa-linkedin" /></a></li>						
					</ul>
					
					<ul className="copyright" >
						<li>© Copyright 2019 Gabriele Cassano</li>
						<li><a title="Styleshout" className="copyright" href="http://profilprofessionnel.com/">Professional Profile</a></li>   
					</ul>
				  </div>
				  
				<div id="go-top"><a className="smoothscroll" title="Back to Top" href="#home"><i className="icon-up-open" /></a></div>
			</div>
		</footer> 
	  }   
      </React.Fragment>
    );
  }
}
